import { DeviceModel } from '@bo-client/activation-management/shared/models/deviceModel';
import {
  CommissioningDistrictHeatingActionTypeEnum,
  CommissioningTariffControlEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';
import { MeteringDevice } from '@bo-client/activation-management/shared/models/meteringDevice';
import { MobileConnectionStrengthEnum } from '@bo-client/activation-management/shared/commissioning-constans';
import { UserDecisionEnum } from '@bo-client/shared/constants/enums';

export class ActionDtoModel {
  id?: number;
  actionType: number | string;
  deviceDesignation?: string;
  connectionPower?: string;
  // Specific gas Fields
  sealingNecessary?: boolean;
  // Specific Water Fields
  ownWaterSupply?: boolean;
  provisionalMeter?: boolean;
  provisionalNeededUntil?: Date;
  facilityType?: string;
  businessType?: string;
  flatDescription?: string;
  meterType?: string;
  newMeterType?: string;
  newRegulatorType?: string;
  totalVolumeFlow?: string;
  totalVolumeFlowM3H?: number;
  deviceLocation?: string;
  transformerNumber?: string;
  transformerSize?: string;
  busbarSize?: string;
  amperage?: string;
  yearlyConsumptionGreaterthreshold?: boolean;
  expectedAnnualConsumption?: number;
  expectedAnnualProduction?: number;
  fixingType?: string;
  comment?: string;
  tariffControl?: CommissioningTariffControlEnum;
  devices: DeviceModel[] = [];
  regulatorAlreadyExits?: boolean;
  // DistrictHeat fields
  existingHeatingType?: CommissioningDistrictHeatingActionTypeEnum;
  existingHeatingConstructionyear?: number | null;
  existingHeatingPower?: number | null;
  existingMiscPower?: number | null;
  existingMiscPowerDesc?: string | null;
  heatingWaterPriority?: boolean | null;
  existingHeatingPowerwater?: number | null;
  suppliesAdditionalBuildings?: boolean;
  additionalBuildingsDescription?: string | null;

  connectionFuseAmplitude?: number | null;
  operationType?: 'continuousOperation' | 'intermittentOperation';

  meterNumber?: string;
  newMeterNumber?: string;

  existingDevice?: MeteringDevice;
  newDevice?: MeteringDevice;
  continuousFlow?: number;
  isFireExtinguishingSystem?: boolean;
  isPressureBoostingSystem?: boolean;

  mobileConnectionStrength?: MobileConnectionStrengthEnum;
  isDeviceReplacement?: boolean;

  isFeederPresent?: UserDecisionEnum;
  feederType?: string;
  isConsumerPresent?: UserDecisionEnum;
  consumerType?: string;
  isAnnualConsumptionExceeded?: UserDecisionEnum;
  erpOrderId?: string;

  mandatoryInstallationCase?: boolean;
}
